export default __webpack_public_path__ + "blog03.jpg";